import { css, buttonHTML, modalHTML } from './assets'
import GoogletagFacade from '../googletagFacade/GoogletagFacade'
import { queryParamHas } from '../helpers/getQueryParam'
import { USP } from './USP'
import WebModel from '../models/WebModel'
import { writeCss } from '../helpers/DOM'

export const modalDataName: IDataNameCCPA = {
  button: 'button',
  checkbox: 'checkbox',
  close: 'close',
  link: 'link'
}

const OPT_OUT = '1YYY'
const isCcpaTest = queryParamHas('test', 'ccpa')

export default class CCPA {
  private _window: Window = window
  private button: HTMLElement
  private customColor: string
  private modal: HTMLElement
  private privacyPolicyLink: string
  private userOptOutStatus: boolean = false

  constructor({ ccpa, custom_cmp_color, privacy_policy_link }: WebModel) {
    if (ccpa === '1' || isCcpaTest) {
      this.customColor = custom_cmp_color
      this.privacyPolicyLink = privacy_policy_link

      if (USP.uspString === OPT_OUT) {
        this.userOptOutStatus = true
      } else {
        USP.userHasReceivedExplictNotice()
      }

      this.insertButton(buttonHTML)
      this.insertModal(modalHTML)

      writeCss(css(this.customColor))
    }
  }

  private handleButtonClick(): void {
    this.modal.style.display = 'block'
  }

  private handleModalClick(event: MouseEvent): void {
    const target = event.target as HTMLElement
    const {
      dataset: { name }
    } = target

    const check = name === modalDataName.checkbox
    const close = name === modalDataName.close
    const optout = name === modalDataName.link

    if (optout) {
      const box = target.nextElementSibling as HTMLInputElement
      if (box && box.type === 'hidden') {
        box.type = 'checkbox'
      }
      if (box && box.type === 'checkbox') {
        box.checked = !box.checked
        this.userOptOutStatus = !this.userOptOutStatus
      }
    }

    if (check) {
      const box = target as HTMLInputElement
      this.userOptOutStatus = box.checked
    }

    if (close) {
      this.modal.style.display = 'none'
    }

    this.handleUserStatus()
  }

  private handleUserStatus(): void {
    if (this.userOptOutStatus) {
      USP.userHasOptedOut()
    } else {
      USP.userHasReceivedExplictNotice()
    }

    GoogletagFacade.onReady(() => {
      this._window.googletag.pubads().setPrivacySettings({
        restrictDataProcessing: this.userOptOutStatus
      })
    }).catch(() => {
      /* noop */
    })
  }

  private insertButton(buttonHTML: Function): void {
    this.button = document.createElement('div')
    this.button.innerHTML = buttonHTML(modalDataName)
    this.button.addEventListener('click', this.handleButtonClick.bind(this))
    document.body.insertAdjacentElement('afterbegin', this.button)
  }

  private insertModal(modalHTML: Function): void {
    this.modal = document.createElement('div')
    this.modal.innerHTML = modalHTML(modalDataName, this.privacyPolicyLink)
    this.modal.addEventListener('click', this.handleModalClick.bind(this))
    this.modal.style.display = 'none'
    document.body.insertAdjacentElement('afterbegin', this.modal)
    // pre populate the checkbox if a user has already opted out
    if (this.userOptOutStatus) {
      const selector = `*[data-name='${modalDataName.checkbox}']`
      const box = this.modal.querySelector(selector) as HTMLInputElement
      if (box) {
        box.type = 'checkbox'
        box.checked = true
        this.handleUserStatus()
      }
    }
  }
}

export interface IDataNameCCPA {
  button: string
  checkbox: string
  close: string
  link: string
}
